import { PatientId, WithPatientId } from '../surgicalEvent.slice';
import { doctorBffApi, InvalidateArr } from '@/modules';
import {
  PhysicalExamination,
  PhysicalExaminationService
} from '@/modules/surgicalEvent';
import { wrapError } from '../../error';
import { constructProtocolCacheKey, ProtocolName } from '@/modules/protocol';

export const physicalExaminationApi = doctorBffApi.injectEndpoints({
  endpoints: (builder) => ({
    physicalExamination: builder.query<PhysicalExamination, PatientId>({
      queryFn: ({ patientId }) =>
        PhysicalExaminationService.getInstance(patientId)
          .fetch()
          .catch(wrapError),
      providesTags: (result, error, { patientId }) => [
        { type: 'PhysicalExamination', id: patientId }
      ]
    }),

    patchPhysicalExamination: builder.mutation<
      PhysicalExamination,
      WithPatientId<Partial<PhysicalExamination>>
    >({
      queryFn: ({ patientId, ...physicalExamination }) =>
        PhysicalExaminationService.getInstance(patientId)
          .patch(physicalExamination)
          .catch(wrapError),
      invalidatesTags: (
        result,
        error,
        { patientId, ...physicalExamination }
      ) => {
        if (error) {
          return [];
        }

        const arr: InvalidateArr = [
          { type: 'PhysicalExamination', id: patientId },
          { type: 'Protocol', id: patientId },
          { type: 'ProtocolStatuses', id: patientId },
          'Dashboard'
        ];

        if (physicalExamination.spO2 !== undefined) {
          arr.push({
            type: 'Scores',
            id: patientId
          });
          arr.push({ type: 'MedicalHo', id: patientId });
        }

        if (physicalExamination.cardiovascularCodes !== undefined) {
          arr.push({
            type: 'Protocol',
            id: constructProtocolCacheKey({
              patientId,
              protocol: ProtocolName.CARDIAC_STRESS_TEST
            })
          });
        }

        return arr;
      }
    })
  }),
  overrideExisting: false
});

export const {
  usePhysicalExaminationQuery,
  usePatchPhysicalExaminationMutation
} = physicalExaminationApi;
